import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../app/api';

const initialState = {
    month_report: [],
    month_report_by_id: {},
    loading: false,
    error: null,
};

export const addMonthReport = createAsyncThunk(
    'month_report/addMonthReport',
    async ({
        date, total, company_id, month, year
    }, { rejectWithValue }) => {
        try {
            const response = await api.post('/month-report/add-month-report', {
                date, total, company_id, month, year
             });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }   
);

export const getMonthReports = createAsyncThunk(
    'month_report/getMonthReports',
    async (dispatch, { rejectWithValue }) => {
        try {
            const response = await api.post('/month-report/get-company-reports', {
                company_id: dispatch.company_id 
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }   
);

export const getMonthReportById = createAsyncThunk(
    'month_report/getMonthReportById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.post(`/month-report/get-report/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }   
);

export const updateMonthReport = createAsyncThunk(
    'month_report/updateMonthReport',
    async ({
        id, total
    }, { rejectWithValue }) => {
        try {
            const response = await api.post(`/month-report/update-month-report/${id}`, {
                total
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }   
);

const clientsSlice = createSlice({
    name: 'month_report',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(addMonthReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addMonthReport.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addMonthReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getMonthReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMonthReports.fulfilled, (state, action) => {
                state.loading = false;
                state.month_report = action.payload.monthReports;
            })
            .addCase(getMonthReports.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getMonthReportById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMonthReportById.fulfilled, (state, action) => {
                state.loading = false;
                state.month_report_by_id = action.payload.monthReport;
            })
            .addCase(getMonthReportById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateMonthReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateMonthReport.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updateMonthReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default clientsSlice.reducer;